import React from "react";
import { Select, MenuItem } from "@mui/material";

const PricingTypeSelect = ({ value, onChange,options }) => {
    return (
        <Select value={value} onChange={onChange} fullWidth  sx={{
            cursor: "pointer",
            backgroundColor: "white",
            height: "42px",
            border: "1px solid #e7e7e7",
            borderRadius: "4px !important",
            "&:hover": { borderColor: "#888" },
            "& .MuiInputBase-root": {
                height: "42px",
                paddingRight: "10px",
            },
            "& .MuiInputAdornment-root": {
                height: "100%",
                display: "flex",
                alignItems: "center",
            },
        }}>
            {
                options.map((option, index) => (
                    <MenuItem key={index} value={option.id}>{option.name}</MenuItem>
                ))
            }
           
        </Select>
    );
};

export default PricingTypeSelect;
